import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import axiosInstance, { baseUrl } from "../../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const ProductSubCategory = () => {
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [image, setImage] = useState("");
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);

  const [search, setSearch] = useState("");
  const storeId = localStorage.getItem("store_id");
  // const superuserId = localStorage.getItem("is_superuser");
  const superuserId = "true";

  const ProductDataList = () => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-show-main-category-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setProductData(response?.data?.main_category_data);

        console.log(response);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  const handleUpdate = (row) => {
    handleOpen1();
    setRowData(row);
    setIds(row?.id);
  };
  useEffect(() => {
    ProductDataList();
  }, []);

  const formik = useFormik({
    initialValues: {
      sub_category_id: rowData?.id ?? "",
      product_main_category_id: rowData?.main_category?.id ?? "",
      product_sub_category_name: rowData?.subcategory ?? "",
      meta_title: rowData?.Meta_Title ?? "",
      meta_description: rowData?.Meta_Description ?? "",
      meta_keyword: rowData?.Meta_Keyword ?? "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const reqBody = new FormData();
      reqBody.append("sub_category_id", values.sub_category_id);
      reqBody.append(
        "product_main_category_id",
        values.product_main_category_id
      );
      rowData?.main_category
        ? reqBody.append("image", image)
        : image && reqBody.append("image", image);
      reqBody.append("meta_title", values.meta_title);
      reqBody.append("meta_keyword", values.meta_keyword);
      reqBody.append("meta_description", values.meta_description);
      reqBody.append(
        "product_sub_category_name",
        values.product_sub_category_name
      );
      rowData?.main_category && reqBody.append("store_id", storeId);
      rowData?.main_category
        ? axiosInstance
            .post(`${baseUrl}api/admin/update-sub-category-data/`, reqBody, {
              headers: {
                Token: localStorage.getItem("Token"),
                "Content-Type": "multipart/formdata",
              },
            })
            .then((response) => {
              toast.success(response.data.message);
              productSubCategoryList();
              console.log("business store ==>", response.data.data);
              handleClose1();
            })
            .catch((error) => {
              console.log("error page", error.response);
              console.log(error);
            })
        : axios
            .post(
              `${baseUrl}api/admin/multivendor-add-product-sub-category/`,
              reqBody,
              {
                headers: {
                  Token: localStorage.getItem("Token"),
                  "Content-Type": "multipart/formdata",
                },
              }
            )
            .then((response) => {
              toast.success(response.data.message);
              productSubCategoryList();
              console.log("business store ==>", response.data.data);
              handleClose1();
            })
            .catch((error) => {
              console.log("error page", error.response);
              console.log(error);
            });
    },
  });

  const productSubCategoryList = () => {
    superuserId !== "true"
      ? axios
          .post(
            `${baseUrl}api/admin/multivendor-show-sub-category-list/?page=${page}&search=${search}`,
            {
              headers: {
                Token: localStorage.getItem("Token"),
                "Content-Type": "multipart/formdata",
              },
            }
          )
          .then((response) => {
            setData(response?.data?.sub_cat_list);
            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
            console.log(
              "sub category data list===>",
              response?.data?.sub_cat_list
            );
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          })
      : axios
          .post(
            `${baseUrl}api/admin/multivendor-show-sub-category-list/?page=${page}&search=${search}`,
            { store_id: storeId },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setData(response?.data?.sub_cat_list);
            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
            console.log(
              "sub category data list===>",
              response?.data?.sub_cat_list
            );
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          });
  };
  useEffect(() => {
    productSubCategoryList();
  }, [page, search]);

  const closeModal = () => {
    handleClose1();
    setIds(null);
    formik.resetForm();
    // formik.values.product_main_category_id("");
    // formik.values.product_sub_category_name("");
  };
  const deleteSubCategory = (id) => {
    axios
      .delete(`${baseUrl}api/admin/update-sub-category-data/`, {
        data: {
          sub_category_id: id,
          // store_id: StoreID,
        },

        headers: {
          Token: localStorage.getItem("Token"),
          // "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        if (response.data.response_code == 200) {
          toast.success(response.data.message);
          productSubCategoryList();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log("error page", error.response);
        console.log(error);
      });
    // }
  };
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Sub Category List
          </p>
          {/* <p className="!text-black">View/Search Product Management List</p> */}
        </div>
        <div className="p-2 pt-5">{/* <CreateResellers /> */}</div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            {/* <CustomIconButton>
              <FilterAlt onClick={handleOpen} className="text-black" />
            </CustomIconButton> */}
            <input
              type="text"
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Button variant="outlined" onClick={handleOpen1}>
                <AddIcon className="" /> Add Sub Category
              </Button>

              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids == null ? "Add Sub Category" : "Update Sub Category"}
                  </div>
                  <form onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Category name
                      </InputLabel>
                      <Select
                        name="product_main_category_id"
                        id="product_main_category_id"
                        label="select store name"
                        size="small"
                        // defaultValue={formik.values.product_main_category_id}
                        value={
                          formik.values.product_main_category_id ||
                          rowData?.main_category?.id ||
                          ""
                        }
                        onChange={formik.handleChange}
                      >
                        {productData?.map((elem) => (
                          <MenuItem value={elem?.id}>{elem?.category}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      id="product_sub_category_name"
                      label="Sub Category Name"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="product_sub_category_name"
                      onChange={formik.handleChange}
                      value={formik.values.product_sub_category_name}
                    />
                    <br />
                    <TextField
                      id="image"
                      type="file"
                      size="small"
                      className="!w-[100%] !mt-3"
                      name="image"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                    <br />
                    <TextField
                      id="meta_title"
                      label="Meta keyword"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_title"
                      onChange={formik.handleChange}
                      value={formik.values.meta_title}
                    />
                    <br />
                    <TextField
                      id="meta_description"
                      label="Meta Title"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_description"
                      onChange={formik.handleChange}
                      value={formik.values.meta_description}
                    />
                    <br />
                    <TextField
                      id="meta_keyword"
                      label="Meta Keyword"
                      size="small"
                      variant="outlined"
                      className="!w-[100%] !mt-3"
                      name="meta_keyword"
                      onChange={formik.handleChange}
                      value={formik.values.meta_keyword}
                    />
                    <br />
                    <Button
                      onClick={closeModal}
                      variant="contained"
                      color="warning"
                      className="!py-2 !mt-3"
                    >
                      CANCEL
                    </Button>
                    {ids === null ? (
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        className="!py-2 !px-8 !mt-3 bg-yellow-300 !float-right"
                      >
                        ADD
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        className="!py-2 !px-5 !mt- bg-yellow-300 !float-right"
                      >
                        UPDATE
                      </Button>
                    )}
                  </form>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  BUSINESS TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  BUSINESS SUB TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  CATEGORY NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  SUB CATEGORY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  IMAGES
                </TableCell>
                {superuserId === "true" ? (
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    ACTION
                  </TableCell>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row?.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.id}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.main_category?.business_type?.business_type?.name
                        ? row?.main_category?.business_type?.business_type?.name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.main_category?.business_type?.name
                        ? row?.main_category?.business_type?.name
                        : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.main_category?.category}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.subcategory}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt="No"
                          className="h-8 mx-auto w-8"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    {superuserId === "true" ? (
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <DeleteIcon
                          onClick={() => {
                            deleteSubCategory(row?.id);
                          }}
                          className="!text-xl !text-red-600 !cursor-pointer"
                        />
                        <button onClick={() => handleUpdate(row)}>
                          <EditIcon className="!text-xl !cursor-pointer !text-green-600" />
                        </button>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {/* {totalPage !== 1 && ( */}
          <div className="flex justify-center p-2">
            <Pagination
              page={currentPage}
              size="small"
              count={totalPage}
              variant="outlined"
              color="primary"
              onChange={handleChangePage}
            />
          </div>
          {/* )} */}
        </TableContainer>
      </div>
    </div>
  );
};

export default ProductSubCategory;
